import { UpdateGroupMemberBulkReq, UpdateGroupMemberPropertyVisibleReq, UpdateGroupMemberStatusReq, UpdateReorderListReq } from '../dto/ReqDtoRepository';
import { GroupMemberListResponse, GroupMemberPropertyVisibleResponse, GroupMemberResponse, LinkedGroupMemberListResponse, SimpleStringResponse } from '../dto/ResDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';

export const getGroupMemberList = async (aui: string): Promise<GroupMemberListResponse> => {
  return sendGetApiRequest<GroupMemberListResponse>(`/api/v1/group-member/list?aui=${encodeURIComponent(aui)}`);
};

export const getGroupMemberListOwner = async (aui: string): Promise<GroupMemberListResponse> => {
  return sendApiRequest<GroupMemberListResponse>('get', `/api/v1/group-member/list/owner?aui=${encodeURIComponent(aui)}`);
};

export const getLinkedGroupMemberListOwner = async (
  aui: string,
): Promise<LinkedGroupMemberListResponse> => {
  return sendApiRequest<LinkedGroupMemberListResponse>(
    'get',
    `/api/v1/group-member/connection/list/owner?aui=${encodeURIComponent(aui)}`,
  );
};

export const unlinkGroupMemberConnection = async (
  aui: string,
  groupMemberId: string,
): Promise<SimpleStringResponse> => {
  return sendDeleteApiRequest<SimpleStringResponse>(
    `/api/v1/group-member/connection?aui=${encodeURIComponent(aui)}&groupMemberId=${encodeURIComponent(groupMemberId)}`,
  );
};

export const createGroupMember = async (aui: string): Promise<GroupMemberResponse> => {
  return sendApiRequest<GroupMemberResponse>('post', `/api/v1/group-member?aui=${encodeURIComponent(aui)}`);
};

export const updateGroupMemberBulk = async (
  aui: string,
  data: UpdateGroupMemberBulkReq,
): Promise<GroupMemberListResponse> => {
  return sendApiRequest<GroupMemberListResponse>(
    'put',
    `/api/v1/group-member/bulk?aui=${encodeURIComponent(aui)}`,
    data,
  );
};

export const updateGroupMemberStatus = async (aui: string, data: UpdateGroupMemberStatusReq): Promise<GroupMemberResponse> => {
  return sendApiRequest<GroupMemberResponse>('put', `/api/v1/group-member/status?aui=${encodeURIComponent(aui)}`, data);
};

export const updateGroupMemberPropertyVisible = async (
  aui: string,
  data: UpdateGroupMemberPropertyVisibleReq,
): Promise<GroupMemberPropertyVisibleResponse> => {
  return sendApiRequest<GroupMemberPropertyVisibleResponse>(
    'put',
    `/api/v1/group-member/property-visible?aui=${encodeURIComponent(aui)}`,
    data,
  );
};

export const reorderGroupMembers = async (
  aui: string,
  data: UpdateReorderListReq,
): Promise<GroupMemberListResponse> => {
  return sendApiRequest<GroupMemberListResponse>(
    'put',
    `/api/v1/group-member/reorder?aui=${encodeURIComponent(aui)}`,
    data,
  );
};

export const deleteGroupMember = async (aui: string, groupMemberId: string): Promise<SimpleStringResponse> => {
  return sendDeleteApiRequest<SimpleStringResponse>(
    `/api/v1/group-member?aui=${encodeURIComponent(aui)}&groupMemberId=${encodeURIComponent(String(groupMemberId))}`
  );
};
